module.exports = __webpack_public_path__ + "images/landing/banner/blog.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/blog.png
// module id = akEf
// module chunks = 118